import _ from 'lodash';
import values from '../resources/c_pais.json';

const CatalogoPais = _.sortBy(values.map(value => ({
  label: value.descripcion,
  value: value.clave
})), 'label');

export default CatalogoPais;